// Layout: Hero With Text
// Scroll-triggered reveal. When the section enters the viewport we add
// `.is-revealed`, which cascades the animation top-to-bottom (image →
// divider draws down → copy) via the staggered transitions in _styles.scss.
(function () {
    function init() {
        const sections = document.querySelectorAll(".hero-with-text");
        if (!sections.length) return;

        const reduceMotion = window.matchMedia(
            "(prefers-reduced-motion: reduce)"
        ).matches;

        if (reduceMotion || !("IntersectionObserver" in window)) {
            sections.forEach((s) => s.classList.add("is-revealed"));
            return;
        }

        const observer = new IntersectionObserver(
            (entries, obs) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("is-revealed");
                        obs.unobserve(entry.target);
                    }
                });
            },
            {
                root: null,
                // Trigger a touch before the section is fully in view so the
                // motion feels connected to the scroll.
                rootMargin: "0px 0px -15% 0px",
                threshold: 0.15,
            }
        );

        sections.forEach((s) => observer.observe(s));
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
